module.exports = __webpack_public_path__ + "img/stage-1.59ace756.png";